import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { getLicenses, readLicenses, getLicense, readLicense } from "./queries";

const useLicenses = () => {
	const result = useQuery(getLicenses);
	const licenses = readLicenses(result.data);

	const activeFirstExpiredLast = ([active, expired]) => [
		...active.sort((a, b) => a.id - b.id),
		...expired.sort((a, b) => new Date(b.expirationDate) - new Date(a.expirationDate)),
	];

	const activeExpiredSplit = ([active, expired], subscr) => {
		// eslint-disable-next-line no-unused-expressions
		subscr.isExpired ? expired.push(subscr) : active.push(subscr);
		return [active, expired];
	};

	licenses.subscriptions = useMemo(
		() => pipe(licenses.subscriptions.reduce(activeExpiredSplit, [[], []]), activeFirstExpiredLast),
		[licenses.subscriptions, activeFirstExpiredLast],
	);

	return [licenses, result];
};

export const useLicense = id => {
	const result = useQuery(getLicense, { variables: { id } });
	return readLicense(result.data);
};

export const usePerpetualLicense = sn => {
	const result = useQuery(getLicenses);
	const licenses = readLicenses(result.data);

	return licenses.perpetuals.find(({ serialNumbers }) => serialNumbers.includes(sn));
};

export default useLicenses;
